import { SET_QUERY_PARAMS, ADD_QUERY_PARAMS } from './actionTypes';
import { keysToLowerCase } from 'utils/object';
import qs from 'query-string';

export function setQueryParams(queryParams) {
  let params = {};
  if (queryParams) {
    params = keysToLowerCase(queryParams);
  } else {
    params = keysToLowerCase(qs.parse(window.location.search));
  }
  return {
    type: SET_QUERY_PARAMS,
    payload: params
  };
}

export function addQueryParams(queryParams) {
  return {
    type: ADD_QUERY_PARAMS,
    payload: keysToLowerCase(queryParams)
  };
}



// WEBPACK FOOTER //
// ./src/store/reducers/queryParams/actions.js